"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAGIC_LINK_INVALID_CODE = exports.RESET_RATE_LIMITED_CODE = exports.urbanAnalysisRequestorForRole = exports.URBAN_ANALYSIS_REQUESTORS = exports.URBAN_ANALYSIS_REQUESTOR = exports.accountLinkSentMessage = exports.ACCOUNT_LINK_KIND = exports.AccountType = void 0;
var account_type_1 = require("./account-type");
Object.defineProperty(exports, "AccountType", { enumerable: true, get: function () { return account_type_1.AccountType; } });
var account_link_1 = require("./account-link");
Object.defineProperty(exports, "ACCOUNT_LINK_KIND", { enumerable: true, get: function () { return account_link_1.ACCOUNT_LINK_KIND; } });
Object.defineProperty(exports, "accountLinkSentMessage", { enumerable: true, get: function () { return account_link_1.accountLinkSentMessage; } });
var urban_analysis_requestor_1 = require("./urban-analysis-requestor");
Object.defineProperty(exports, "URBAN_ANALYSIS_REQUESTOR", { enumerable: true, get: function () { return urban_analysis_requestor_1.URBAN_ANALYSIS_REQUESTOR; } });
Object.defineProperty(exports, "URBAN_ANALYSIS_REQUESTORS", { enumerable: true, get: function () { return urban_analysis_requestor_1.URBAN_ANALYSIS_REQUESTORS; } });
Object.defineProperty(exports, "urbanAnalysisRequestorForRole", { enumerable: true, get: function () { return urban_analysis_requestor_1.urbanAnalysisRequestorForRole; } });
/**
 * Error code the password-reset request returns when the caller has exhausted
 * the per-IP rate limit (`PASSWORD_RESET_RATE_LIMIT_MAX` requests per
 * `PASSWORD_RESET_RATE_LIMIT_WINDOW_MINUTES`).
 *
 * The endpoint is deliberately constant-response — it always reports success so
 * that no one can probe which addresses have accounts. Being throttled is the
 * single exception: the request genuinely was not processed, and a user told
 * "check your mailbox" would wait for an email that is never coming. The
 * limiter is keyed on IP, so its answer is identical whether or not the address
 * exists, and surfacing it leaks nothing.
 *
 * Shared because it is a contract across the boundary: the backend route emits
 * it in `extensions.code`, the forgot-password page switches on it. Hasura
 * returns HTTP 200 for action errors, so the code is the only reliable signal.
 */
exports.RESET_RATE_LIMITED_CODE = 'reset-rate-limited';
/**
 * Error code every unusable magic link comes back as — unknown, malformed,
 * expired, already clicked, revoked by a newer one, or belonging to an account
 * that may no longer sign in.
 *
 * Deliberately ONE code for all of them: the holder of a bad link learns
 * nothing about why, and the page does not need to know either — it always
 * does the same thing, which is to fall back to the sign-in form with the
 * address filled in. An expired link is a detour, never a dead end.
 */
exports.MAGIC_LINK_INVALID_CODE = 'magic-link-invalid';
//# sourceMappingURL=index.js.map